export const AverageGrade = () => {
    return (
        <div className="flex flex-row items-baseline">
            <span className="font-medium text-[32px] leading-8 text-valley-dark-green">
                0
            </span>
            <span className="font-light text-2xl leading-6 text-valley-dark-green">
                .0{" "}
            </span>
            <span className="font-light text-2xl leading-6 text-valley-light-gray">
                %
            </span>
        </div>
    )
}